import { render, staticRenderFns } from "./TemplateSelection.vue?vue&type=template&id=58771459"
import script from "./TemplateSelection.vue?vue&type=script&lang=js"
export * from "./TemplateSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports